import React from 'react';
function VelocityIcon() {
  return (
    <svg width='28' height='28' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='32' height='32' rx='8' fill='#8CCC43' />
      <path
        d='M9.28905 17.6316L16.2782 6.6486C16.5468 6.22658 17.2 6.41682 17.2 6.91704V14.7C17.2 14.7552 17.2448 14.8 17.3 14.8H22.2397C22.6442 14.8 22.8813 15.2554 22.6493 15.5867L15.7097 25.5006C15.4293 25.901 14.8 25.7027 14.8 25.2138V18.5C14.8 18.4448 14.7553 18.4 14.7 18.4H9.71089C9.31634 18.4 9.07723 17.9644 9.28905 17.6316Z'
        stroke='white'
        stroke-width='2'
      />
    </svg>
  );
}

export default VelocityIcon;
